export { default } from './PaymentMethodsSection';
